import { Edit } from '@features/ForestOwner/Search/Overview/Edit'
import { createFileRoute } from '@tanstack/react-router'

interface EditForestOwnerSearch {
  changeTo?: 'organization'
}

export const Route = createFileRoute('/forestowner/$forestownerId/edit/')({
  validateSearch: (search: Record<string, unknown>): EditForestOwnerSearch => ({
    changeTo: search.changeTo === 'organization' ? 'organization' : undefined,
  }),
  component: Edit,
  staticData: {
    breadcrumb: 'Endre skogeieropplysninger',
  },
})
